import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {HomeComponent} from './components/home/home.component';
import {EndlessBlowComponent} from './components/portfolio/endless-blow/endless-blow.component';
import {PortfolioComponent} from './components/portfolio/portfolio.component';
import {AppLocationComponent} from './components/portfolio/app-location/app-location.component';
import {ObjectsMeasurementComponent} from './components/portfolio/objects-measurement/objects-measurement.component';
import {DribblerComponent} from './components/portfolio/dribbler/dribbler.component';
import {NotepadComponent} from './components/portfolio/notepad/notepad.component';
import {
  EndlessBlowResetPasswordComponent
} from './components/portfolio/endless-blow/endless-blow-reset-password/endless-blow-reset-password.component';
import {NotFoundComponent} from './components/errors/not-found/not-found.component';
import {AboutComponent} from './components/about/about.component';
import {ProductNotesComponent} from './components/portfolio/product-notes/product-notes.component';
import {AssocWordsComponent} from './components/portfolio/assoc-words/assoc-words.component';
import {ExchangeRatesComponent} from './components/portfolio/exchange-rates/exchange-rates.component';
import {RickAndMortyComponent} from './components/portfolio/rick-and-morty/rick-and-morty.component';
import {AiBasedAudioProcessingComponent} from './components/portfolio/ai-based-audio-processing/ai-based-audio-processing.component';

const routes: Routes = [
  {path: '', redirectTo: 'home', pathMatch: 'full'},
  {path: 'home', component: HomeComponent},
  {path: 'portfolio', component: PortfolioComponent, pathMatch: 'full'},
  {path: 'portfolio/endless-blow', component: EndlessBlowComponent},
  {path: 'portfolio/endless-blow/reset-password', component: EndlessBlowResetPasswordComponent},
  {path: 'portfolio/objects-measurement', component: ObjectsMeasurementComponent},
  {path: 'portfolio/dribbler', component: DribblerComponent},
  {path: 'portfolio/notepad', component: NotepadComponent},
  {path: 'portfolio/app-location', component: AppLocationComponent},
  {path: 'portfolio/product-notes', component: ProductNotesComponent},
  {path: 'portfolio/assoc-words', component: AssocWordsComponent},
  {path: 'portfolio/exchange-rates', component: ExchangeRatesComponent},
  {path: 'portfolio/rick-and-morty', component: RickAndMortyComponent},
  {path: 'portfolio/ai-based-audio-processing', component: AiBasedAudioProcessingComponent},
  {path: 'about', component: AboutComponent},
  {path: '404', component: NotFoundComponent},
  {path: '**', component: NotFoundComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
